// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Parceiro } from "../interfaces/Parceiro";
// --------------------- Import Interface ---------------------

export const atualizarParceiroService = async (
  parceiroId: number | undefined,
  parceiroData: Parceiro
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/parceiro/${parceiroId}`;
    try {
      const response = await axios.patch(URL, parceiroData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
